export default __webpack_public_path__ + "static/media/loading.b4b2c237.png";